import { ProcessType } from "../../../../../Shared/IST/Resource/Content";
import { processTypeEnum } from "../Resource/Contents";

export class ProcessTypeHelper {
    static getProcessTypeEnum = (processType?: ProcessType): processTypeEnum => {
        if (processType == ProcessType.NB) {
            return processTypeEnum.NewBusiness;
        }
        if (processType == ProcessType.NBEC) {
            return processTypeEnum.NewBusinessExistingClient;
        }
        if (processType == ProcessType.Quote) {
            return processTypeEnum.Quote;
        }
        if (processType == ProcessType.SinglePayment) {
            return processTypeEnum.SinglePaymentTransfer;
        }
        if (processType == ProcessType.AddRegular || processType == ProcessType.EditRegular) {
            return processTypeEnum.RegularPayment;
        }
        if (processType == ProcessType.TopUpWithITFLS) {
            return processTypeEnum.topUpWithITFLS;
        }
        return null;
    };
}
